export type ResizeGestureStart = {
  x: number
  y: number
  width: number
  height: number
}

export const anchoredPosition = (
  handle: string,
  start: ResizeGestureStart,
  size: { width: number; height: number },
): { x: number; y: number } => ({
  x: handle.includes('w') ? start.x + (start.width - size.width) : start.x,
  y: handle.includes('n') ? start.y + (start.height - size.height) : start.y,
})
